import React, { useState, useEffect } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom'
import { Form, Button, Container, Row, Col, Card, Alert } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import Message from '../components/Message'
import Loader from '../components/Loader'
import { inventoryDetail, updateInventory } from '../actions/inventoryActions'
import { INVENTORY_UPDATE_RESET } from '../constants/inventoryConstants'
import { getItems } from '../actions/itemActions'
import { getAllnames } from '../actions/nameActions'

const InventoryUpdate = () => {
  const { id } = useParams()

  const [upc, setUpc] = useState('')
  const [manufacturers, setName] = useState('')
  const [subname, setSubname] = useState('')
  const [item, setItem] = useState('')
  const [qty, setQty] = useState(0)
  const [prevqty, setprevQty] = useState(0)
  const [lowinventory, setLowinventory] = useState('')
  const [cost, setCost] = useState('')
  const [price, setPrice] = useState('')
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    variant: 'success'
  })
  const [onetimeload, setOnetimeLoad] = useState(true)

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const inventoryDetails = useSelector((state) => state.inventoryDetails)
  const { loading, success, unit } = inventoryDetails

  const inventoryUpdate = useSelector((state) => state.inventoryUpdate)
  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate
  } = inventoryUpdate

  const itemList = useSelector((state) => state.itemList)
  const { items } = itemList

  const nameAll = useSelector((state) => state.nameAll)
  const { manufacturer } = nameAll

  useEffect(() => {
    if (successUpdate) {
      dispatch({ type: INVENTORY_UPDATE_RESET })
      navigate('/inventory')
    } else {
      dispatch(inventoryDetail(id))
      dispatch(getItems())
      dispatch(getAllnames())
    }
  }, [dispatch, id, successUpdate, navigate])

  useEffect(() => {
    if (unit && success) {
      setUpc(unit.upc)
      setName(unit.manufacturer)
      setSubname(unit.subname)
      setItem(unit.item)
      setQty(unit.qty)
      setprevQty(unit.qty)
      setLowinventory(unit.lowinventory)
      setCost(unit.cost)
      setPrice(unit.price)
      setOnetimeLoad(false)
    }
  }, [unit, onetimeload, success])

  const itemlist = Object.keys(items).map((key) => {
    return (
      <option key={key} value={items[key].item}>
        {items[key].item}
      </option>
    )
  }, this)

  const nameslist = Object.keys(manufacturer).map((key) => {
    return (
      <option key={key} value={manufacturer[key].manufacturer}>
        {manufacturer[key].manufacturer}
      </option>
    )
  }, this)

  // Change handler
  function showAlert(message, variant = 'success', seconds = 3000) {
    setAlert({
      show: true,
      message,
      variant
    })

    setTimeout(() => {
      setAlert({
        show: false,
        message: '',
        variant: 'success'
      })
    }, seconds)
  }

  // Submit handler
  const onSubmit = (e) => {
    e.preventDefault()
    if (window.confirm('Are you sure?')) {
      dispatch(
        updateInventory({
          _id: id,
          upc,
          manufacturer: manufacturers,
          subname,
          item,
          qty: parseInt(qty) + parseInt(prevqty),
          lowinventory,
          cost,
          price
        })
      )
      dispatch({ type: INVENTORY_UPDATE_RESET })
      showAlert('Inventory Updated', 'success')
    }
  }

  return (
    <Container>
      {alert.show && <Alert variant={alert.variant}>{alert.message}</Alert>}
      {loading && <Loader />}
      {loadingUpdate && <Loader />}
      {errorUpdate && <Message variant='danger'>{errorUpdate}</Message>}
      <Row className='my-3'>
        <Col>
          <Link to='/inventory' className='btn btn-primary my-2'>
            Go Back
          </Link>
        </Col>
      </Row>

      <h3>Edit Inventory Entry</h3>

      <Card className='mt-3 mb-3'>
        <Card.Body>
          <Form onSubmit={onSubmit}>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>UPC</Form.Label>
                  <Form.Control
                    placeholder='UPC'
                    value={upc}
                    onChange={(e) => setUpc(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Item</Form.Label>
                  <Form.Control
                    as='select'
                    value={item}
                    onChange={(e) => setItem(e.target.value)}
                  >
                    {itemlist}
                  </Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>Manufacturer</Form.Label>
                  <Form.Control
                    as='select'
                    value={manufacturers}
                    onChange={(e) => setName(e.target.value)}
                  >
                    {nameslist}
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Subname</Form.Label>
                  <Form.Control
                    type='text'
                    placeholder='Subname'
                    value={subname}
                    onChange={(e) => setSubname(e.target.value)}
                  ></Form.Control>
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>Quantity being added to: {unit.qty}</Form.Label>
                  <Form.Control
                    placeholder='Qty'
                    value={qty}
                    onChange={(e) => setQty(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label htmlFor='price'>Low Inventory Level</Form.Label>
                  <Form.Control
                    type='number'
                    className='w-25'
                    min='0'
                    step='1'
                    placeholder='0'
                    value={lowinventory}
                    onChange={(e) => setLowinventory(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Form.Group>
                  <Form.Label>Cost</Form.Label>
                  <Form.Control
                    type='number'
                    min='0.01'
                    step='0.01'
                    placeholder='Cost'
                    value={cost}
                    onChange={(e) => setCost(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group>
                  <Form.Label>Price</Form.Label>
                  <Form.Control
                    type='number'
                    min='0.01'
                    step='0.01'
                    placeholder='Price'
                    value={price}
                    onChange={(e) => setPrice(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row className='my-2'>
              <Col></Col>
            </Row>
            <Row className='my-3'>
              <Col>
                <Button variant='primary' type='submit' size='sm'>
                  Update
                </Button>{' '}
              </Col>
            </Row>
          </Form>
        </Card.Body>
      </Card>
    </Container>
  )
}

export default InventoryUpdate
